/**
 * What has been drawn, so it can be drawn again.
 *
 * Changing the basemap calls mapbox `setStyle`, which drops every custom
 * source and layer on the map. Aircraft tracks disappeared while their ids
 * stayed in `window.affTracks`, leaving the registry and the map disagreeing —
 * and leaving the user looking at an empty map after asking to see a track.
 *
 * Keeping the GeoJSON and the chosen colours lets the layer re-add the tracks
 * once the new style has loaded.
 */
import type { AffTrackSpan } from '../../../components/explorers/affExplorer/affTrackEvent';

export interface DrawnTrack {
  trackId: string;
  /** The tracker asked for, so a redrawn entry can be retimed by ESN. */
  esn?: string;
  data: any;
  color: string;
  halo: string;
  /** Aircraft label, so a re-registered drawer entry keeps its name (#802). */
  name?: string;
  /** The span drawn, so a re-registered drawer entry keeps its timeframe (#866 M4). */
  span?: AffTrackSpan;
}

const tracks = new Map<string, DrawnTrack>();

export const rememberTrack = (track: DrawnTrack): void => {
  tracks.set(track.trackId, track);
};

export const forgetTrack = (trackId: string): void => {
  tracks.delete(trackId);
};

export const forgetAllTracks = (): void => {
  tracks.clear();
};

export const drawnTracks = (): DrawnTrack[] => Array.from(tracks.values());
